import React from 'react';
import { PointTransaction } from '../../data/go2LegendeMock';

interface Props {
  transactions: PointTransaction[];
}

export const PointsHistory: React.FC<Props> = ({ transactions }) => {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden mt-8">
      <div className="px-6 py-4 border-b border-gray-100">
        <h3 className="text-lg font-bold text-go2-pink">Istorija Bodova</h3>
      </div>
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Datum</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Tip</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Opis</th>
              <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Bodovi</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {transactions.map((tx) => (
              <tr key={tx.id} className="hover:bg-gray-50">
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  {tx.date}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full 
                    ${tx.type.includes('Zarada') ? 'bg-green-100 text-green-800' : 
                      tx.type === 'Iskorišćeno' ? 'bg-brand-100 text-brand-800' : 
                      'bg-gray-100 text-gray-800'}`}>
                    {tx.type}
                  </span>
                </td>
                <td className="px-6 py-4 text-sm text-go2-pink">
                  {tx.description}
                </td>
                <td className={`px-6 py-4 whitespace-nowrap text-sm font-bold text-right 
                  ${tx.points > 0 ? 'text-green-600' : 'text-red-500'}`}>
                  {tx.points > 0 ? '+' : ''}{tx.points}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
